import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "shared/ui/shadcn/select";
import { FC } from "react";
import { PropsWithClassNameI } from "shared/lib/interfaces/ui";
import { clsxMerge } from "shared/lib/helpers/styles";

/**
 * Select the number of days to wait before sending the follow-up email
 *
 * @param value{string} - The number of days to wait (e.g. "1")
 * @param onChange{function} - The function to call when the value changes
 * @returns
 */
export const SelectDays: FC<
  PropsWithClassNameI & { value: string; onChange?: (value: string) => void }
> = ({ className, value, onChange }) => {
  const daysOptions = Array.from({ length: 7 }, (_, i) => ({
    value: `${i + 1}`,
    label: `${i + 1}`,
  }));

  const handleDaysChange = (value: string) => {
    onChange?.(value);
  };

  return (
    <Select value={value} onValueChange={handleDaysChange}>
      <SelectTrigger
        className={clsxMerge("w-[60px] focus:ring-transparent", className)}
      >
        <SelectValue placeholder="Select days" />
      </SelectTrigger>
      <SelectContent>
        {daysOptions.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
